import React, { useEffect, useState, useRef } from "react";
import Countdown from "react-countdown";
import Button from "@material-ui/core/Button";
import { base_url } from "../../Api/Api";
import { Loader } from "../../Global/Loader";
import { Popup } from "../../Global/Popup";

import ItemWinner from "./itemWinner";

const LotteryDetailes = (props) => {
  const [state, setState] = useState({
    data: null,
    loader: true,
    rank: ["اول", "دوم", "سوم"],
    days: "0",
    hours: "00",
    minutes: "00",
    loaderStatus: false,
    popupStatus: false,
  });

  const Days = useRef(0);
  const Hours = useRef(0);
  const Minutes = useRef(0);

  useEffect(() => {
    updateData();
  }, []);

  const updateData = () => {
    window.scrollTo(0, 0);

    base_url
      .get(`lottery/${props.match.params.id}`)
      .then((response) => {
        console.log(response.data.lottert);
        setState({
          ...state,
          data: response.data.lottert,
          loader: false,
          loaderStatus: false,
          popupStatus: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  };

  // Renderer callback with condition
  const timerRender = ({ days, hours, minutes, completed }) => {
    if (
      Days.current.innerText != undefined &&
      Hours.current.innerText != undefined &&
      Minutes.current.innerText != undefined
    ) {
      Days.current.innerText = days;
      Hours.current.innerText = hours == 0 ? "00" : hours;
      Minutes.current.innerText = minutes == 0 ? "00" : minutes;
    }
    if (completed) {
      return (
        <>
          <span>00</span>
          <span>00</span>
          <span>0</span>
        </>
      );
    } else {
      // Render a countdown
      return (
        <span>
          {days}:{hours}:{minutes}
        </span>
      );
    }
  };

  const lotteryRegister = () => {
    setState({
      ...state,
      loaderStatus: true,
    });
    const Data = {
      lottery_id: state.data.id,
    };
    console.log(Data);

    base_url
      .post("lottery_register", Data)
      .then((response) => {
        console.log(response);
        setState({
          ...state,
          loaderStatus: false,
          popupStatus: true,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            props.history.push(`/Entrance`);
          }
        }
      });
  };

  return (
    <div className="instructpg lottery details-lattery">
      <Loader active={state.loader} />
      <Popup active={state.popupStatus} classes="popup-lotteries">
        <h4>شما با موفقیت در قرعه کشی ثبت نام کردید.</h4>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={updateData}>
            خروج
          </Button>
        </div>
      </Popup>

      <div className="Header">
        <span className="cat-title">
          قرعه کشی
          <i
            className="icon-arrow-down-sign-to-navigate"
            onClick={() => props.history.goBack()}
          ></i>
        </span>
      </div>
      <div className="body-lottery">
        <h4>{state.data == null ? "" : state.data.title}</h4>

        <div className="remain-time">
          <div className="time">
            <span>زمان باقی مانده</span>
            <div
              className={`times ${
                state.data == null
                  ? ""
                  : state.data.time_secound <= 0
                  ? "expire"
                  : ""
              }`}
            >
              <div className="conter">
                <span ref={Days}>{state.days}</span>
                <span>روز</span>
              </div>
              <div className="conter">
                <span ref={Hours}>{state.hours}</span>
                <span>ساعت</span>
              </div>
              <div className="conter">
                <span ref={Minutes}>{state.minutes}</span>
                <span>دقیقه</span>
              </div>
              <div className="cmpnt-timer">
                {state.data == null ? null : (
                  <Countdown
                    date={Date.now() + state.data.time_secound * 1000}
                    renderer={timerRender}
                  />
                )}
              </div>
            </div>
          </div>
          {state.data == null ? (
            ""
          ) : state.data.register_count == 0 ? (
            <span className="count-register">
              شما در این قرعه کشی شرکت نکرده اید
            </span>
          ) : (
            <span className="count-register">
              تعداد دفعات شرکت در این قرعه کشی : {state.data.register_count}
            </span>
          )}
          <div className="row-scors">
            <div className="scrs">
              <span>امتیاز شما : </span>
              <b>{state.data == null ? "" : state.data.user_score}</b>
            </div>
            <div className="scrs">
              <span>حداقل امتیاز : </span>
              <b>{state.data == null ? "" : state.data.required_score}</b>
            </div>
          </div>
        </div>

        <span className="title-ltr">جزییات قرعه کشی</span>
        {state.data == null ? (
          <span className="no-content">اطلاعاتی وجود ندارد</span>
        ) : (
          <p>{state.data.description}</p>
        )}
        <span className="title-ltr">جوایز برندگان</span>
        <div className="list-winner">
          {state.data == null ? (
            <span className="no-content">اطلاعاتی وجود ندارد</span>
          ) : state.data.awards.length == 0 ? (
            <span className="no-content">اطلاعاتی وجود ندارد</span>
          ) : (
            state.data.awards.map((item, index) => (
              <div className="rank">
                <strong> {item.title} :</strong>
                <span>{item.description} </span>
              </div>
            ))
          )}
        </div>
        {/* <div className="btn-base btn-black btn-sircle">
                    {state.data == null ? '' :
                        state.data.can_register ?
                            <Button
                                variant="contained"
                                disabled={state.loaderStatus}
                                onClick={lotteryRegister} >شرکت در قرعه کشی</Button>
                            :
                            <div className="btn-expire">
                                <Button
                                    variant="contained">شرکت در قرعه کشی</Button>
                            </div>
                    }
                </div> */}
      </div>
    </div>
  );
};

export default LotteryDetailes;
